/* eslint-disable no-unused-vars */
import { TimeEntryErrorModel } from './timeEntryErrorModel'
import ResultDTO from '@/models/app/resultDTO'
import TimeEntryAPIErrorContext from '@/constants/booking/timeEntries/TimeEntryAPIErrorContext'
import ErrorResponseDTO from '@/models/error/errorResponseDTO'

export class TimeEntryClockOutErrorModel extends TimeEntryErrorModel {
  /** @param {ResultDTO<ErrorResponseDTO>} errorResponse */
  constructor(errorResponse) {
    super(errorResponse, TimeEntryAPIErrorContext.clockOut)

    /**
     * See {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_wiki/wikis/anzuk%20Dev%20Team/366/Ready2Work-2.0?anchor=post-/api/v1.0/time-entries/clock-out Error Code Wiki}
     * @type {string[]}
     */
    this.errorCodesToRefresh = [
      'security_error',
      'auto_clocked_out',
      'booking_in_future',
      'booking_not_found',
      'pending_action_to_clock_out',
      'already_clocked_out',
    ]
  }

  /** @override */
  shouldTriggerTimeEntryStatusRefresh() {
    return this.errorCodesToRefresh.includes(this.errorCode)
  }
}
